import { classNamesFunction } from '@fluentui/react';
import React, { useCallback, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { defaultBreakpoints } from './Carousel.constants';
import { FeedCarousel } from './Carousel/FeedCarousel';
import { getWindowSize } from './Carousel/FeedCarousel.utilities';
var getClassNames = classNamesFunction();
export var CarouselBase = function (props) {
    var _a = useState(3), cardsPerSlide = _a[0], setCardsPerSlide = _a[1];
    var _b = props.breakpoints, breakpoints = _b === void 0 ? defaultBreakpoints : _b, prevItemAriaLabel = props.prevItemAriaLabel, nextItemAriaLabel = props.nextItemAriaLabel;
    var onResize = useCallback(function (width) {
        if (width) {
            var cardItemsPerSlide = getWindowSize(width, breakpoints).items;
            setCardsPerSlide(cardItemsPerSlide);
        }
    }, []);
    var _c = useResizeDetector({
        onResize: onResize,
        refreshMode: 'throttle',
        refreshOptions: {
            trailing: true
        }
    }), width = _c.width, ref = _c.ref;
    var itemNo = useState(0)[0];
    var classNames = getClassNames(props.styles);
    var title = props.title, viewAllLink = props.viewAllLink, viewAllOnClick = props.viewAllOnClick, viewAllText = props.viewAllText, items = props.items, itemWidth = props.itemWidth, responsive = props.responsive;
    return (React.createElement("div", { className: classNames.container, ref: ref }, !!width && (React.createElement(FeedCarousel, { currentFocusElement: itemNo, header: title, viewAllLink: viewAllLink, viewAllOnClick: viewAllOnClick, viewAllText: viewAllText, items: items, width: width, cardsPerSlide: cardsPerSlide, responsive: responsive, itemWidth: itemWidth, prevItemAriaLabel: prevItemAriaLabel, nextItemAriaLabel: nextItemAriaLabel }))));
};
//# sourceMappingURL=Carousel.base.js.map